var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuote4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "47px",
    viewBox: "0 0 52 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6363636,14.9545455 L25.6363636,21.4234545 C25.6363636,26.4161364 22.3698636,29.7766364 17.766,30.6845909 L16.8986364,28.8259545 C19.0264545,28.0248182 20.3958636,25.4355455 20.3958636,23.5 L17.0909091,23.5 L17.0909091,14.9545455 L25.6363636,14.9545455 Z M36.3181818,14.9545455 L36.3181818,21.4234545 C36.3181818,26.4161364 33.0516818,29.7766364 28.4478182,30.6845909 L27.5804545,28.8259545 C29.7082727,28.0248182 31.0776818,25.4355455 31.0776818,23.5 L27.7727273,23.5 L27.7727273,14.9545455 L36.3181818,14.9545455 Z M25.6363636,4.27272727 C37.4162727,4.27272727 47,11.9465455 47,21.3785909 C47,31.8830909 36.0084091,38.3861818 25.8286364,38.3861818 C21.6905,38.3861818 18.6013182,37.5380455 16.4414545,37.0103636 C14.3050909,38.3199545 13.0339545,39.2257727 7.31490909,40.8985455 C8.45786364,37.9653182 8.8595,35.0278182 8.601,31.7869545 C6.81072727,29.6505909 4.27486328,26.6596818 4.27486328,21.3785909 C4.27272727,11.9465455 13.8564545,4.27272727 25.6363636,4.27272727 Z M25.6363636,0 C12.0960909,0 0,9.02827273 0,21.3785909 C0,25.7581364 1.57663636,30.0586364 4.37313636,33.3956364 C4.49063636,37.3051818 2.18763636,42.9152727 0.115363636,47 C5.67418182,45.9959091 13.5765909,43.7783636 17.1592727,41.5821818 C20.1886364,42.3192273 23.0876818,42.6567727 25.8307727,42.6567727 C40.9647727,42.6567727 51.2748636,32.3231818 51.2748636,21.3764545 C51.2727273,8.96204545 39.0933182,0 25.6363636,0 Z",
    id: "Shape",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote4);
export default __webpack_public_path__ + "static/media/Quote 4.bc845d2e.svg";
export { ForwardRef as ReactComponent };